export const shenHeList = [
    {
        value: -1,
        label: '审核失败',
    },{
        value: 1,
        label: '审核中',
    },{
        value: 2,
        label: '审核通过',
    }
]
export const enableList = [
    {
        value: -3,
        label: '拉黑',
    },{
        value: -2,
        label: '注销',
    },{
        value: -1,
        label: '冻结',
    },{
        value: 0,
        label: '审核中',
    },{
        value: 1,
        label: '正常',
    }
]
export const genderList = [
    {
        value: 1,
        label: '男',
    },{
        value: 2,
        label: '女',
    }
]
export const vipList = [
    {
        value: true,
        label: '是',
    },{
        value: false,
        label: '否',
    }
]

export const payTypeList = [
    {
        value: 1,
        label: '会员',
    },{
        value: 2,
        label: '交换私聊',
    },{
        value: 3,
        label: '交换相册',
    },{
        value: 4,
        label: '发布动态',
    }
]

export const payStateList = [
    {
        value: 1,
        label: '支付完成 ',
    },{
        value: 0,
        label: '未支付',
    }
]

